<div
  class="quick-links left PrintProcedureHide"
  [ngClass]="{ SideBar: isEnglish, 'SideBar-ar': isArabic }"
>
  <div>
    <ul
      id="ctl21_lstSummary"
      class="submenu ui-corner-top widget widget-shaded"
      [ngClass]="{ 'submenu-en': isEnglish, 'submenu-ar': isArabic }"
    >
      <li>
        <h2>{{ 'UserProfile.UsefulLinks' | translate }}</h2>
      </li>
      <li>
        <a routerLink="/login">{{ 'UserProfile.Login' | translate }}</a>
      </li>
      <li>
        <a
        href="javascript:void(0)"
        (click)="goTo('ElectronicRefundURL')"
          >{{ 'UserProfile.ElectronicRefund' | translate }}</a
        >
      </li>
      <li class="Tooltip">
        <a
          href="javascript:void(0)"
          (click)="openUserManual('../../../assets/Images/Manual/')"
          >{{ 'UserProfile.DSUserManual' | translate }}</a
        ><span class="tooltiptext" style="width: 165px"
                  ><div [style.text-align]="isArabic ? 'right' : 'left'" style="padding: 5px">
                    <p>
                      <strong>{{ 'UserProfile.FileName' | translate }}:</strong>
                      {{ 'UserProfile.UserManual' | translate }}
                    </p>
                    <p>
                      <strong>{{ 'UserProfile.FileSize' | translate }}:</strong>
                      890 KB
                    </p>
                    <p>
                      <strong>{{ 'UserProfile.FileType' | translate }}:</strong>
                      PDF
                    </p>
                  </div></span
                >
      </li>
      <li>
        <a
        href="javascript:void(0)"
          (click)="goTo('DigitalCertificatesAndPermitsHubURL')"
          >{{ 'UserProfile.DigitalCertificatesAndPermitsHub' | translate }}</a
        >
      </li>
    </ul>
  </div>
</div>
